export function thousandsSeparator(val) : string {
    if (val !== undefined && val !== null) 
    {
      if (val == '' || /[a-zA-Z ]/.test(val) || isNaN(parseInt(val)))
        return '';
      else {
        if (typeof val === 'string')
          val = val.replace(/[\.,]/g, '');
        return parseInt(val).toLocaleString();
      }
    } else {
      return '';
    }
}


// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/theme/functions/thousandsSeparator.function.ts